import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { useAddOnsPage } from '../../../hooks/useAddOnPage';
import { SectionTitle } from '../../common/SharedComponents';
import HubPlanPickerRowAll from './HubPlanPickerRowAll';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledPlanPickerWrapper = styled.div.withConfig({
  displayName: "HubPlanPickerListContainerAll__StyledPlanPickerWrapper",
  componentId: "sc-1ozaqsz-0"
})(["display:flex;flex-direction:column;flex:1;width:inherit;"]);
const HubPlanPickerListContainerAll = ({
  productLines,
  compact = false
}) => {
  const {
    showAddonsPage
  } = useAddOnsPage();
  return /*#__PURE__*/_jsxs(StyledPlanPickerWrapper, {
    children: [!compact && /*#__PURE__*/_jsx(SectionTitle, {
      children: showAddonsPage ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProducts"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.selectProductsAndAddons"
      })
    }), productLines.map(productLine => /*#__PURE__*/_jsx(HubPlanPickerRowAll, {
      productLine: productLine,
      compact: compact
    }, productLine))]
  });
};
export default HubPlanPickerListContainerAll;